import type { FC } from "react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { Background, Button } from "~/shared/ui-kit";
import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Title } from "~/shared/ui-kit/title/Title";

import type { StepsProps } from "../Steps";
import { NumberInCircle } from "./NumberInCircle";

export const StepsRow: FC<StepsProps> = (props) => {
  const { data, getUrl, onCallAction, isControlInactive } = props;
  const controlAction = data?.action;
  const action = data?.action?.action?.[0];

  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  const handlePressButton = (): void => {
    if (!controlAction || !action) return;

    const isInactive = isControlInactive(controlAction);
    if (!isInactive) {
      onCallAction(action);
    }
  };
  return (
    <Background
      bgValue="linear-gradient(68.17deg, #590FD1 8.74%, #FF3D00 64.57%, #FFAE10 102.86%)"
      dBgValue="linear-gradient(89.95deg, #590FD1 0.03%, #FF3D00 58.39%, #FFAE10 114.93%)"
    >
      <Flex
        flexDirection="column"
        justify="center"
        align="center"
        className="max-w-[1240px] mx-auto py-8"
        gap={20}
        d={{ flexDirection: "row", justify: "space-between" }}
      >
        <Flex
          flexDirection="column"
          flexWrap="wrap"
          align="center"
          gap={24}
          d={{ flexDirection: "row", justify: "space-around", gap: 16 }}
        >
          {data.steps_items.map((item, index) => (
            <Flex
              flexDirection="column"
              justify="flex-start"
              align="center"
              key={item.text}
              gap={8}
              d={{ flexDirection: "row", gap: 16 }}
              className="xl:min-w-[294px] md:min-w-[240px]"
            >
              <NumberInCircle index={index + 1} />
              <Title as="h4" size="small" weight="bold" className="text-center">
                {item.text}
              </Title>
            </Flex>
          ))}
        </Flex>
        <Button
          href={href}
          variant="accent"
          size="medium"
          weight="bold"
          className="min-w-fit mt-6 lg:m-0 lg:px-12 lg:py-[18px] px-6 py-3 text-center"
          onPress={handlePressButton}
        >
          {data.action_text}
        </Button>
      </Flex>
    </Background>
  );
};
